import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import find from "lodash/find";
import moment from "moment";
import sortBy from "lodash/sortBy";
import { connect } from "react-redux";
import {
  Card,
  Button,
  CardTitle,
  CardText,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";
import { TbRefreshOff , TbRefresh} from "react-icons/tb";
import { deepClone } from "../../../../../utils/copyObject";
import Loading from "../../../../../hoc/Loading/Loading";
import axios from "../../../../../axios";
import * as actionCreators from "../../../../../modules/actions/index";
import {
  kpiBasedType,
  chartLineColor,
  plotlyMarkerTypes,
  benchmarkLineTypes,
  dtickFormat,
  dashboardChartSize,
  returnHierarchyGroup,
  KPISbyMonth,
  chartMarkerSymbolsVariation,
  chartMarkerSymbols,
  checkUserPrivileges,
} from "../../../../../utils/constants";
import {
  getGenderLists,
  createKPIAgreegateRequestDataRefreshChart,
  getAllOccupationAndSeniorityValues,
} from "../../../../../utils/filterKpisData";
import { generateLegendTitle } from "../../../../../utils/chartUtils";
import Plot from "../../../../../utils/customPlotly";
import ManualEntryModal from "../../../../../pages/analytics/ChartList/ManualEntryModal";
import * as url from "../../../../../utils/url";
import ViewChart from "../../../../../pages/analytics/ViewChart/ViewChart";
import InsightIcon from "../../../../../assets/insight.png";
import Spinner from "../../../../../assets/spinner.gif";
import DashboardChartPlot from "./DashboardChartPlot";

class DashboardChartItem extends Component {
  chartMenuRef = React.createRef();
  chartMenuBtnRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      chart: this.props.chart,
      // chart: null,
      random: "",
      isUpdateData: false,
      isLoading: false,
      dashboardChartMenu: false,
      rangeInit: [],
      showViewChart: false,
      clickedPoint: null,
      isChartNotesDisplay: false,
      showManualEntryAnswersModal: false,
      plotlyData: null,
      dropdownOpen: false,
      dropdownFilter: false,
    };
  }

  componentDidMount() {
    let { chart_id, currentDashboard } = this.props;
    console.log("Mounted");

    // this.fetchChartdata(chart_id, currentDashboard._id);
    document.addEventListener("mousedown", this.handleDbClickOutside);
  }

  fetchChartdata = (chartId, currentDashboardId) => {
    // Todo: replace this with get single chart api once get that api url
    axios
      .post(url.getDashboardCharts, { dashboardId: currentDashboardId })
      .then(({ data }) => {
        let result = data && data.data && data.data.length > 0 ? data.data : [];

        const chart = result.find(x => x._id === chartId);

        this.setState({ chart: chart });
      })
      .catch(err => {
        console.log("dbchlist: ", err);
      });
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleDbClickOutside);
  }

  handleDbClickOutside = event => {
    //  console.log('event.target: ', event.target)
    let chartMenu =
      this.chartMenuRef &&
      this.chartMenuRef.current &&
      !this.chartMenuRef.current.contains(event.target);
    let chartMenuBtn =
      this.chartMenuBtnRef &&
      this.chartMenuBtnRef.current &&
      !this.chartMenuBtnRef.current.contains(event.target);

    if (chartMenu) {
      if (chartMenuBtn && chartMenu) {
        this.closeFilterMenu();
      }
    }
  };

  closeFilterMenu = () => {
    this.setState(prevState => ({ dropdownFilter: false }));
  };

  renderFilterDropdown = () => {
    let { chart } = this.state;
    let { user, currentDashboard } = this.props;
    let isEdit = checkUserPrivileges(user.profile, currentDashboard);
    if (chart) {
      return (
        <Dropdown
          isOpen={this.state.dashboardChartMenu}
          toggle={() => {
            this.setState({
              dashboardChartMenu: !this.state.dashboardChartMenu,
            });
          }}
          style={{ float: "right" }}
        >
          <DropdownToggle
            className="chart-item-menu"
            tag="span"
            data-toggle="dropdown"
            aria-expanded={this.state.dashboardChartMenu}
          >
            <i
              className="chart-item-menu flaticon-menu-1"
              style={{ cursor: "pointer" }}
            ></i>
          </DropdownToggle>
          <DropdownMenu className="dbChartMenuOptions" style={{ padding: "0" }}>
            <DropdownItem
              className="dbChartViewModal"
              onClick={() => this.navigateToChart(chart)}
            >
              {" "}
              <i className="flaticon-vision" /> View Chart
            </DropdownItem>
            {checkUserPrivileges(user.profile, currentDashboard) ? (
              <DropdownItem
                className="dbChartRemove"
                onClick={() => this.removeChart(chart)}
              >
                <i className="flaticon-trash" /> Remove
              </DropdownItem>
            ) : null}
          </DropdownMenu>
        </Dropdown>
      );
    } else {
      return null;
    }
  };

  chartLineMarkerGenerator = (color, type) => {
    let obj;

    if (type === "line") {
      obj = {
        color,
        width: 1,
      };
    } else {
      let marker = Math.floor(Math.random() * 9);
      let variation = Math.floor(Math.random() * 3);
      let symbol = `${chartMarkerSymbols[marker]}${chartMarkerSymbolsVariation[variation]}`;
      obj = {
        color,
        size: 10,
        symbol,
      };
    }
    return obj;
  };

  kpiGoalValue = (chart, kpi, index) => {
    if (chart && chart.goals && chart.goals.length > 0) {
      if (kpi && kpi.kpiId && kpi.kpiId._id) {
        let result = chart.goals.filter(
          e =>
            e.kpiId === kpi.kpiId._id &&
            parseInt(e.name.match(/\d+/)[0]) === index + 1
        );
        if (result && result.length > 0) {
          return result[0];
        }
      }
    }
    return {};
  };

  handleChartPointClick = a => {
    let { chart } = this.state;
    if (chart && chart.name && chart.kpiType) {
      let { kpiType } = chart;
      if (kpiType === kpiBasedType.surveyBased) {
        this.setState({
          showManualEntryAnswersModal: true,
          clickedPoint: a,
        });
      }
    }
  };

  openChartMenu = () => {
    this.setState(prevState => ({
      dropdownFilter: !prevState.dropdownFilter,
    }));
  };

  onPlotlyUpdate = plot => {
    let { chart } = this.state;

    if (chart && chart._id) {
      let { rangeInit } = this.state;
      if (plot && plot.layout && plot.layout.xaxis) {
        let { range } = plot.layout.xaxis;
        if (
          rangeInit &&
          rangeInit != null &&
          rangeInit.length > 1 &&
          range &&
          range.length > 1
        ) {
          let plotlyDTick = dtickFormat(range[0], range[1]);
          let pTick2 = dtickFormat(rangeInit[0], rangeInit[1]);
          if (pTick2 != plotlyDTick) {
            this.setState({ rangeInit: range, plotlyDTick });
          }
        } else {
          this.setState({ rangeInit: range });
        }
      }
    }
  };

  removeChart = item => {
    let { reports, chartOrder } = this.props;

    const chartsOrdered = [...chartOrder];

    const removeIndex = chartsOrdered.findIndex(x => x._id === item._id);

    if (removeIndex >= 0) {
      chartsOrdered.splice(removeIndex, 1);
    }

    let results = {
      filters: {
        _id: item._id,
        dashboardId: reports._id,
      },
      chartRef: item.chartId,
      dateRange: { startDate: item.startDate, endDate: item.endDate },
      name: item.name,
      chart: { ...item },
      chartOrder: chartsOrdered,
    };

    item = { ...item, isRemoveFlag: true };
    let that = this;
    that.props.updateReportCharts(item);

    axios
      .post(url.archiveDashboardChart, results)
      .then(response => {
        let dashboard = response.data.data;
        delete dashboard.createdBy;

        that.props.updateReport(dashboard);
      })
      .catch(error => {
        console.log("err--", error);
      });
  };

  toggleTaskView = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  renderPlotSize = chart => {
    if (chart) {
      let { col_size } = chart;
      let { user, currentDashboard } = this.props;
      let isEdit = checkUserPrivileges(user.profile, currentDashboard);
      if (isEdit) {
        return (
          <span>
            Chart size
            <Dropdown
              isOpen={this.state.dropdownOpen}
              toggle={this.toggleTaskView}
              className="dbPlotSizeDropdown"
            >
              <DropdownToggle caret className="dashboardChartSizeBtn">
                {dashboardChartSize[col_size]["name"]}
              </DropdownToggle>
              <DropdownMenu className="singleTaskViewMenu">
                <DropdownItem header>Change chart size</DropdownItem>
                <DropdownItem
                  className="chartBtnView"
                  onClick={() => this.changeChartSize(3)}
                >
                  Small
                </DropdownItem>
                <DropdownItem
                  className="chartBtnView"
                  onClick={() => this.changeChartSize(4)}
                >
                  Medium
                </DropdownItem>
                <DropdownItem
                  className="toolkitBtnView"
                  onClick={() => this.changeChartSize(6)}
                >
                  Large
                </DropdownItem>
                <DropdownItem
                  className="toolkitBtnView"
                  onClick={() => this.changeChartSize(12)}
                >
                  Full
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </span>
        );
      } else {
        return null;
      }
    }
  };

  changeChartSize = size => {
   


    let { chart } = this.state;

    
      let { reports } = this.props;

      let results = {
        chartId: chart._id,
        dashboardId: reports._id,
        updateAttr: {
          col_size: size,
        },
      };
      chart = { ...chart, col_size: size };
      // let that=this
      this.setState({ chart });
      // this.props.updateReportCharts(chart); /// <-- this action is what is taking the page a long time it seems
      this.props.changeSize(chart);
  
      axios
        .post(url.updateDashboardChart, results)
        .then(response => {})
        .catch(error => {
          console.log("err--", error);
        });
    
   
  };

  navigateToChart = value => {
    if (value == "isChartNotesDisplay") {
      this.setState({ showViewChart: true, isChartNotesDisplay: true });
    } else {
      this.setState({ showViewChart: true });
    }
  };

  closeViewChartModal = () => {
    this.setState({ showViewChart: false });
  };

  renderNewChartAlert = () => {
    let { chart } = this.state,
      { reports } = this.props;
    let dbDate =
      moment(chart.dashboardDate) > moment(reports.dashboardDateUpdate);
    let dbUpdate =
      chart.dashboardDateUpdate == null ||
      moment(chart.dashboardDateUpdate) != moment(reports.dashboardDateUpdate);
    if (dbDate && dbUpdate) {
      return (
        <div className="dashboardNewChartContainer">
          <span className="dashboardNewChartAlert">New chart</span> as of{" "}
          {moment(chart.dashboardDate).format("MMM Do, YYYY")}
        </div>
      );
    }
  };


  renderChartStatus=()=>{
    let { chart } = this.state;
    if(chart.lockedDate){
      return (
        <div className="dashboardPreviewCat mb-4">Chart is locked <TbRefreshOff size='14px'/></div>
       )
     }else {
       return (
        <div className="dashboardPreviewCat mb-4">Chart is active <TbRefresh size='14px'/></div>
      )
    }
  }

  renderView = () => {
    let { showViewChart, isLoading, chart } = this.state;
    if (chart && chart._id ) {
      return (
        <div className={`card dashboardSinglePreviewCard`}>
          <div className="card-body">
            <span className="dashboardChartTitleContainer">
              <span className="dashboardTitleText" onClick={() => this.navigateToChart(chart)}>{chart.name}</span>
            </span>
            <span className="dashboardChartItemMenu">
              {/* <i className="flaticon-down-arrow" onClick={()=>this.openChartMenu()} ref={this.chartMenuBtnRef} />  */}
              {/* ref={this.chartMenuBtnRef} */}
              {this.renderFilterDropdown()}
            </span>
            <span className="dashboardPreviewCat">from {chart.category} </span>

            <span className="dbPlotSize">{this.renderPlotSize(chart)}</span>
            {/* dashboardDateUpdate */}
            {this.renderChartStatus()}
            {this.renderNewChartAlert()}

            {isLoading ? (
              <div className="dashboardChartLoaderContainer">
                <img src={Spinner} className="dashboardChartLoader" />
              </div>
            ) : null}
            {chart ? <DashboardChartPlot chart={chart} /> : null}
          </div>

          <Modal isOpen={showViewChart} className="viewSingleChartModal">
            <ViewChart
              closeViewChartModal={this.closeViewChartModal}
              isChartNotesDisplay={this.state.isChartNotesDisplay}
              chart={chart}
            />
          </Modal>
        </div>
      );
    } else {
      return <div>Retrieving charts...</div>;
    }
  };

  render() {
    return this.renderView();
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
    reportCharts: state.reports.charts,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    onChartSelected: chart => dispatch(actionCreators.onChartSelected(chart)),
    updateReport: dashboard => dispatch(actionCreators.updateReport(dashboard)),
    updateReportCharts: dashboard =>
      dispatch(actionCreators.updateReportCharts(dashboard)),
  };
};

// export default LinkedCharts;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(DashboardChartItem, axios)));
